var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('span',{staticClass:"bacon-select-info",attrs:{"aria-hidden":"true"}},[_vm._v("i")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }